import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Box, Button, Typography } from 'shared/ui'
import { useEventKnowledgeBaseUpdated } from 'entities/KnowledgeBase'
import { KnowledgeBasePath } from 'pages/settings/pages/knowledgeBase/route/knowledgeBasePath'
import {
  type IPointKnowledgeBaseUsageProps,
  PointKnowledgeBaseUsage,
} from 'pages/chatbot/ui/AgentKnowledgeBase/ui/PointKnowledgeBaseUsage/PointKnowledgeBaseUsage'
import styles from './styles.module.scss'

export type IAgentKnowledgeBaseProps = IPointKnowledgeBaseUsageProps & { isOnlyButton?: boolean }

export const AgentKnowledgeBase = observer(
  ({ isOnlyButton, ...props }: IAgentKnowledgeBaseProps) => {
    const { initKnowledgeBase, updateKnowledgeBase } = props.agentKnowledgeBaseStore
    useEffect(() => {
      initKnowledgeBase()
    }, [])

    useEventKnowledgeBaseUpdated(updateKnowledgeBase)

    const pointKnowledgeCommonProps = {
      title: 'AI Knowledge Base',
      ...props,
    }

    if (isOnlyButton) {
      return <PointKnowledgeBaseUsage isShowGoToKnowledgeBase {...pointKnowledgeCommonProps} />
    }
    return (
      <Box display={'flex'} flexDirection={'column'} marginTop={1.5} gap={1} marginBottom={3}>
        <div className={styles.dataSourcesContainer}>
          <Typography
            variant={'body-sm-regular'}
            ariaLabel={'Data sources'}
            color={'var(--content-primary-tertiary)'}
          >
            Data sources
          </Typography>
          <Button
            typeBtn='informative'
            size='small'
            contained='secondary'
            text='Go to knowledge base'
            onClick={() => {
              window.open(`/${KnowledgeBasePath.root}`, '_blank')
            }}
            style={{ textDecoration: 'none' }}
          />
        </div>
        <PointKnowledgeBaseUsage {...pointKnowledgeCommonProps} />
      </Box>
    )
  }
)
